import ActiveItemClaimPrizeButton from "./ActiveItemClaimPrizeButton";
import ActiveItemReturnIdentityButton from "./ActiveItemReturnIdentityButton";
import { usePopup } from "hooks/usePopup";
import { useLocation, useNavigate } from "react-router-dom";
import { useSoundPath } from "hooks/useSoundPath";
import useActiveItem from "hooks/useActiveItem";

const ActiveItemCraftButton = ({ data, isListed }) => {
  const {pathname} = useLocation();
  const {activeItem} = useActiveItem();
  const setPopupHook = usePopup();
  const navigate = useNavigate();
  const playSound = useSoundPath();

  const getType = () => {
    if (data.text === "Craft Identity") {
      return "identity";
    } else if (data.text === "Craft Prediction") {
      return "prediction";
    }
  };

  const claimPrizeHandler = () => setPopupHook({ type: 'claim-prize' });

  const returnIdentity = () => setPopupHook({ type: 'return-identity' });

  const craftHandler = () => {
    playSound('main');
    if (isListed) {
      if (data.text === "Craft Identity") {
        setPopupHook({ type: "cancel-listing-identity" });
      } else if (data.text === "Craft Prediction") {
        setPopupHook({ type: "cancel-listing-prediction" });
      }
    } else {
      const cardRarity = activeItem.properties.find((prop) => prop.title === "Rarity")?.text;
      const activeBlock = activeItem.properties.find((prop) => prop.title === "Type")?.text;

      const params = new URLSearchParams();
      params.append('type', getType());
      params.append('activeBlock', activeBlock.charAt(0).toUpperCase() + activeBlock.slice(1));
      params.append('card', JSON.stringify(activeItem));
      params.append('activeTag', activeBlock.charAt(0).toUpperCase() + activeBlock.slice(1));
      params.append('cardRarity', cardRarity);

      const queryString = params.toString();
      navigate(`${data.linkPath}?${queryString}`);
    }
  };

  if ((pathname.includes('prizes') || pathname.includes('triggers')) || (pathname.includes('events') && activeItem.is_valid_event === false)) return null;

  if (data.text.toLowerCase() === "resolved true") {
    return (
      <ActiveItemClaimPrizeButton icon={data.icon} text='Claim Prize' claimPrizeHandler={claimPrizeHandler} />
    );
  }

  if (data.text.toLowerCase() === "resolved false") {
    return (
      <ActiveItemReturnIdentityButton icon={data.icon} text='Return Identity' returnIdentity={returnIdentity} />
    );
  }

  if (data.text.toLowerCase() !== activeItem.tag.toLowerCase()) {
    return (
      <button
        className="card-details__button card-details__button--craft"
        onClick={craftHandler}
      >
        <img src={data.icon} alt="" />
        {data.text}
      </button>
    );
  }

  else return null;
};

export default ActiveItemCraftButton;
